<template>
  <div class="filter-custom-bank d-flex">
    <div class="label-filter">Filtros</div>
    <div v-if="got_feature('feature_can_use_payable_or_receivable_effects') && workWithEffects" class="item-filter orange-filter white--text" :class="option_selected && option_selected['code'] == 'contains_effects'? 'selected': ''" @click="changeSelection('contains_effects')"><div class="inside-item">P</div></div>
    <div class="item-filter yellow-filter white--text" :class="option_selected && option_selected['code'] == 'default_counterpart'? 'selected': ''" @click="changeSelection('default_counterpart')"><div class="inside-item">A</div></div>
    <div class="item-filter gray-filter white--text" :class="option_selected && option_selected['code'] == 'none'? 'selected': ''" @click="changeSelection('none')"><div class="inside-item">-</div></div>
  </div> 
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'BankSimpleFilters',
  props: {    
    workWithEffects: {
      type:Boolean,
      default: false
    }
  },
  data () {
      return { 
        option_selected: null
      }
  },
  computed: {
    ...mapGetters({
      got_feature:'got_feature',
    })
  },
  methods: {
    changeSelection(sel) {
      if (this.option_selected && this.option_selected['code'] == sel) {
        this.option_selected = null
      }
      else {
        this.option_selected = {
          code:sel          
        }
      }
      this.$emit('updateSimpleFilter',{})
    }
  }
}
</script>
<style scoped>
.filter-custom-bank {
    border-radius: 8px;
    background: rgba(217, 217, 217, 0.50);
    padding-left:9px;    
    font-weight: bold;
    align-items: center;
    margin-top:20px;
    width:fit-content;
  }
  .filter-custom-bank .label-filter {
    vertical-align: middle;
  }
  .filter-custom-bank .item-filter {
    border-radius: 8px;
    padding:5px;
    margin-left:5px;
    cursor:pointer;
    margin-right:auto;
  }
  .filter-custom-bank .item-filter.yellow-filter.selected {   
    background: rgba(247, 188, 37, 0.50);
  }
  .filter-custom-bank .item-filter.orange-filter.selected {    
    background: rgba(243, 108, 11, 0.50);
  }
  .filter-custom-bank .item-filter.gray-filter.selected {       
    background: rgba(144, 144, 147, 0.50);
  }
  .filter-custom-bank .item-filter .inside-item{
    width:19px;
    height: 19px;
    border-radius:4px;
    text-align: center;
    font-weight: bold;  
  }  
  .filter-custom-bank .item-filter.yellow-filter .inside-item{
    background-color:#F7BC25;
  }
  .filter-custom-bank .item-filter.orange-filter .inside-item{
    background-color:#F36C0B;
  }
  .filter-custom-bank .item-filter.gray-filter .inside-item{
    background-color:#909093;
  }

</style>